import { render, staticRenderFns } from "./SendFile.vue?vue&type=template&id=f4b1fcc4&scoped=true&"
import script from "./SendFile.vue?vue&type=script&lang=js&"
export * from "./SendFile.vue?vue&type=script&lang=js&"
import style0 from "./SendFile.vue?vue&type=style&index=0&id=f4b1fcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b1fcc4",
  null
  
)

export default component.exports